<div class="ilb-overlay" *ngIf="image" (click)="close()">
  <button class="ilb-close" type="button" (click)="close()" aria-label="Close">
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
      <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
    </svg>
  </button>

  <button
    class="ilb-nav ilb-nav--prev"
    type="button"
    *ngIf="hasMultiple"
    (click)="$event.stopPropagation(); prev()"
    aria-label="Previous image">
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="15 18 9 12 15 6"/>
    </svg>
  </button>

  <img
    class="ilb-image"
    [class.ilb-image--zoomed]="scale > 1"
    [src]="image.url"
    [style.transform]="'translate(' + translateX + 'px, ' + translateY + 'px) scale(' + scale + ')'"
    (click)="$event.stopPropagation(); toggleZoom($event)"
    (wheel)="onWheel($event)"
    (pointerdown)="$event.stopPropagation(); onPointerDown($event)"
    (pointermove)="onPointerMove($event)"
    (pointerup)="onPointerUp()"
    (pointerleave)="onPointerUp()"
    alt="{{ image.caption }}" />

  <button
    class="ilb-nav ilb-nav--next"
    type="button"
    *ngIf="hasMultiple"
    (click)="$event.stopPropagation(); next()"
    aria-label="Next image">
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="9 18 15 12 9 6"/>
    </svg>
  </button>

  <div class="ilb-footer" (click)="$event.stopPropagation()">
    <span class="ilb-caption" *ngIf="image.caption">{{ image.caption }}</span>
    <span class="ilb-counter" *ngIf="hasMultiple">{{ counterLabel }}</span>
  </div>
</div>
